import {
  ADD_ORDER_SHIPMENT_LINE_REQUEST,
  ADD_ORDER_SHIPMENT_LINE_SUCCESS,
  ADD_ORDER_SHIPMENT_LINE_ERROR,
  UPDATE_ORDER_SHIPMENT_LINE_REQUEST,
  UPDATE_ORDER_SHIPMENT_LINE_SUCCESS,
  UPDATE_ORDER_SHIPMENT_LINE_ERROR,
  GET_ALL_ORDER_SHIPMENT_LINE_REQUEST,
  GET_ALL_ORDER_SHIPMENT_LINE_SUCCESS,
  GET_ALL_ORDER_SHIPMENT_LINE_ERROR,
  DELETE_ORDER_SHIPMENT_LINE_ERROR,
  DELETE_ORDER_SHIPMENT_LINE_SUCCESS,
  DELETE_ORDER_SHIPMENT_LINE_REQUEST,
  GET_ONE_ORDER_SHIPMENT_LINE_REQUEST,
  GET_ONE_ORDER_SHIPMENT_LINE_SUCCESS,
  GET_ONE_ORDER_SHIPMENT_LINE_ERROR,
  GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_REQUEST,
  GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_SUCCESS,
  GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_ERROR,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_ORDER_SHIPMENT_LINE_REQUEST:
      return {
        loading: true,
      };

    case ADD_ORDER_SHIPMENT_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };

    case UPDATE_ORDER_SHIPMENT_LINE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    case UPDATE_ORDER_SHIPMENT_LINE_REQUEST:
      return {
        loading: true,
      };

    case UPDATE_ORDER_SHIPMENT_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: [payload],
      };

    case ADD_ORDER_SHIPMENT_LINE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    case DELETE_ORDER_SHIPMENT_LINE_REQUEST:
      return {
        loading: true,
      };
    case DELETE_ORDER_SHIPMENT_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case DELETE_ORDER_SHIPMENT_LINE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    case GET_ALL_ORDER_SHIPMENT_LINE_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_ORDER_SHIPMENT_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ALL_ORDER_SHIPMENT_LINE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ONE_ORDER_SHIPMENT_LINE_REQUEST:
      return {
        loading: true,
      };
    case GET_ONE_ORDER_SHIPMENT_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ONE_ORDER_SHIPMENT_LINE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    case GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_REQUEST:
      return {
        loading: true,
      };
    case GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ONE_ORDER_SHIPMENT_LINE_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default:
      return state;
  }
}
